"use client"; // Ensure compatibility with Next.js App Router

import React, { useEffect, useRef, useState } from "react";
import Link from "next/link";
import Button from "@/components/CommonComponent/button";
import styled from "styled-components";
import Image from "next/image";
import Slider from "react-slick";
import { FaChevronUp, FaChevronDown, FaUserCircle } from "react-icons/fa";
import { MdOutlineVerified } from "react-icons/md";
import { BsArrowDown, BsArrowUp } from "react-icons/bs";
import { MdOutlineStar } from "react-icons/md";
import DynamicPoints from "@/Data/RandomPoints.json";
import { div } from "framer-motion/client";
import Popupform from "@/components/serviceComponent/popupform";
import { X ,ChevronLeft, ChevronRight } from "lucide-react";
import { motion } from "framer-motion";
import { Input, message } from "antd";
import { GoArrowUpRight } from "react-icons/go";

const Banner = ({
  image_alt,
  image,
  text1,
  link1,
  text2,
  link2,
  title,
  description,
  cluth,
  slug,
}: any) => {
  const sliderRef = useRef<Slider | null>(null); // Specify correct ref type
  const [websiteUrl, setWebsiteUrl] = useState("");
  const [apiError, setApiError] = useState("");
  const [inputError, setInputError] = useState(false);
  const [showform, setshowform] = useState(false);
  const [isMobile, setIsMobile] = useState(false)
  const [currentSlide, setCurrentSlide] = useState(0)
  const [submitting, setSubmitting] = useState(false);
  // console.log(text2,"yyy");

  const handleSeoAuditClick = async () => {
     message.destroy(); 
    setInputError(false);

    // Basic URL validation
    if (!websiteUrl) {
      message.error("Please enter a website URL");
      setInputError(true);
      return;
    }

    try {
      setSubmitting(true);

      // Validate URL format
      const urlPattern =
        /^https?:\/\/(www\.)?[a-z0-9-]+(\.[a-z]{2,63})+(:\d+)?(\/[^\s?#]*)?(\?[^\s#]*)?(#[^\s]*)?$/i;
      if (!urlPattern.test(websiteUrl)) {
        message.error(
          "Please enter a valid website URL (e.g., https://example.com)"
        );
        setInputError(true);
        return;
      }

      // Call your API endpoint
      const response = await fetch("https://www.w3era.com/api/website-leads/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ url: websiteUrl }),
      });

      if (response.status === 200) {
        // message.success('Website analysis complete!');
        setApiError("");
        setshowform(true);
        // console.log(response, "yyyy");
      } else {
        const errorData = await response.json();
        message.error(
          errorData.error || "Failed to analyze website. Please try again."
        );
      }
    } catch (error) {
      console.error("API Error:", error);
      message.error("An unexpected error occurred. Please try again later.");
    }finally {
      setSubmitting(false);
    }
  };

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false, // Hide default arrows
  };
  const settings1 = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 3 } },
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 640, settings: { slidesToShow: 1 } },
    ],
  };
  const renderStars = (rating: number) => {
    const stars = [];
    for (let i = 0; i < 5; i++) {
      if (i < rating) {
        stars.push(<MdOutlineStar key={i} className="text-pink text-[18px]" />);
      } else {
        stars.push(
          <MdOutlineStar key={i} className="text-gray-300 text-[18px]" />
        );
      }
    }
    return stars;
  };
  const [randomPoints, setRandomPoints] = useState<any>();
  useEffect(() => {
    const shuffled = DynamicPoints.statistics.sort(() => 0.5 - Math.random());
    setRandomPoints(shuffled.slice(0, 3));
  }, []);


  useEffect(() => {
    if (showform) {
      
      document.body.style.overflow = 'hidden';
    } else {
      
      document.body.style.overflow = 'auto';
    }

    
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [showform]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 640)
    }

    handleResize()

    window.addEventListener("resize", handleResize)

    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === randomPoints.length - 1 ? 0 : prev + 1))
  }

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? randomPoints.length - 1 : prev - 1))
  }

  return (
    <div className=" bg-[url('/images/priya/banner1-bg.svg')] bg-center bg-cover bg-no-repeat">
      <div className="flex flex-col justify-center w-full h-fit py-4 bg-center">
        <div className="mx-auto xl:w-[95%] 2xl:w-[80%] px-6 flex justify-center">
          <div className="flex justify-between flex-wrap lg:flex-nowrap  items-start py-4 md:py-10 gap-7">
            <div className=" w-fit  !lg:w-1/2 items-center lg:items-start flex flex-col gap-6">
              <h1 className=" text-white  font-bold">{title || ""}</h1>

              <StyledWrapper>
                <div
                  className="!text-white text-[20px]"
                  dangerouslySetInnerHTML={{ __html: description || "" }}
                ></div>
              </StyledWrapper>
              {/* <div className="relative  w-full hidden sm:block max-w-[345px] sm:max-w-[445px] ">
                                <div className="absolute sm:top-1/2   sm:right-[-50px] transform -translate-y-1/2 flex flex-col gap-2">
                                    <button
                                        className="p-2 bg-white rounded-full shadow-md "
                                        onClick={() => sliderRef.current?.slickPrev()}
                                    >
                                        <BsArrowUp
                                            className="text-pink text-[20px] font-semibold" />
                                    </button>
                                    <button
                                        className="p-2 bg-white rounded-full shadow-md "
                                        onClick={() => sliderRef.current?.slickNext()}
                                    >
                                        <BsArrowDown className="text-pink text-[20px]  font-semibold" />
                                    </button>
                                </div>
                                <Slider ref={sliderRef} {...settings}>
                                    {cluth?.map((testimonial: any, index: number) => (
                                        <div key={index} className="p-6 !flex  gap-4 items-start justify-between bg-white rounded-lg shadow-md">
                                            <div className="md:w-1/2">
                                                <div className="flex  gap-4">
                                                    <span className="min-w-10 min-h-10 mt-2">
                                                        <FaUserCircle className="text-homegrey text-[38px]" />
                                                    </span>
                                                    <div>
                                                        <span className="font-semibold">{testimonial?.position}</span>
                                                    </div>
                                                </div>
                                                <div className='flex my-1 text-pink items-center text-[20px]'>{testimonial?.rating || 5.0}
                                                    {renderStars(testimonial?.rating || 5)}
                                                </div>
                                                <div className="flex items-center gap-1"><MdOutlineVerified />
                                                    Verified Review</div>
                                            </div>
                                            <div className=" w-1/2 text-gray-700">{testimonial?.review}</div>
                                        </div>
                                    ))}
                                </Slider>
                            </div> */}
              <div className="flex  gap-3 justify-center md:justify-start sm:gap-5 items-center">
                {slug !== "seo/services/seo-audit" ? (
                  <Link href={link1 || ""}>
                    <Button content={text1} />
                  </Link>
                ) : (
                  <div className="w-full flex flex-col md:flex-row gap-3 items-center">
                  <div className="w-full md:flex-1">
                    <Input
                      placeholder="Enter website URL"
                      className={`w-full p-3 md:p-3 md:w-[22rem]  rounded-lg border ${
                        inputError
                          ? "border-red-500 focus:border-red-500"
                          : "border-gray-300 focus:border-blue"
                      } outline-none transition text-base`}
                      value={websiteUrl}
                      onChange={(e) => {
                        setWebsiteUrl(e.target.value);
                        if (inputError) setInputError(false);
                      }}
                      size="large"
                    />
                  </div>
                  <div  onClick={handleSeoAuditClick} className="w-full md:w-auto md:mt-3" style={{ pointerEvents: submitting ? 'none' : 'auto' }}>
                    <Button
                      content={submitting ? (
                        <span className="flex items-center justify-center gap-2">
                          <svg className="animate-spin h-5 w-5 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                          </svg>
                          Get Free Website...
                        </span>
                      ) : "Get Free Website Audit"}
                      className="w-full md:w-auto whitespace-nowrap"
                      disabled={submitting}
                      loading={submitting}
                    />
                  </div>
                </div>
                )}
                {/* {
                                    link2 &&
                                    <Link href={`/${link2}` || ''}>
                                        <Button content={text2} />
                                    </Link>
                                } */}
                {link2 &&
                  text2 &&
                  slug !== "seo/services/seo-audit" &&
                  (link2.includes("tel:") ? (
                    <a href={link2}>
                      <Button content={text2} />
                    </a>
                  ) : link2.includes("http") ? (
                    <Link
                      href={link2}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button content={text2} />
                    </Link>
                  ) : (
                    <Link href={`/${link2}`} passHref>
                      <Button content={text2} />
                    </Link>
                  ))}
              </div>
              {/* <div className="flex items-center gap-3 mt-2 flex-wrap justify-center sm:justify-start">
              <span className="text-white text-[20px] font-semibold">Top Rated Company on Upwork</span>
              <div className='w-fit'>
                <a
                  href="https://www.upwork.com/agencies/671438752084221952/"
                  rel="nofollow noopener noreferrer"
                  target="_blank"
                  aria-label="Hire us on Upwork"
                  className="inline-block"
                >
                   <button className="text-white text-[18px] gap-3 flex items-center border-[2px] rounded-full p-[2px]  border-lightpink 
                                          font-medium  group  transition-all duration-300">
                                                  <div className="w-[45px] h-[45px] flex bg-white/10 justify-center items-center rounded-full
                                          border-lightpink border-[1px] transform transition-transform duration-300  group-hover:rotate-45 group-hover:translate-x-2">
                                                      <GoArrowUpRight className="-rotate-30 group-hover:text-white text-[28px] text-white" />
                                                  </div>
                                                  <span className="transform mr-4 transition-transform  duration-300 group-hover:translate-x-2">
                                                      <p >{"Hire Now"}</p>
                                                  </span>
                                          </button>
                </a>
              </div>
            </div> */}
            </div>
            <div className="w-full  flex justify-center !lg:w-1/2 rounded-lg lg:block">
              <div>
                {image && (
                  <div className="flex justify-center">
                    <Image
                      src={image || ""}
                      alt={image_alt}
                      height={490}
                      width={490}
                    />
                  </div>
                )}

                 {isMobile ? (
                  <div className="w-full mt-6 relative px-4 pb-12">
                    <div className="custom-slider relative">
                      <div className="flex justify-center">
                        {randomPoints.length > 0 && (
                          <div className="flip-card mx-auto min-w-[180px] size-[180px] min-h-[180px]">
                            <div className="flip-card-inner">
                              <div className="flip-card-front flex items-center justify-center p-2 text-center">
                                <Image
                                  src={"/case-study/tick_banner.svg"}
                                  alt={image_alt}
                                  height={100}
                                  width={100}
                                  className="absolute z-50 -top-10 left-10"
                                />
                                <div className="title text-[14px]">
                                  <span className="text-[28px] text-blue">{randomPoints[currentSlide]?.value}</span>
                                  <br />
                                  {randomPoints[currentSlide]?.title}
                                </div>
                              </div>
                              <div className="flip-card-back flex items-center justify-center p-2 text-center">
                                <Image
                                  src="/case-study/tick_banner.svg"
                                  alt="Tick Back"
                                  height={100}
                                  width={100}
                                  className="absolute z-50 -top-10 right-10"
                                />
                                <div className="title text-[14px]">{randomPoints[currentSlide]?.description}</div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>


                      <button
                        onClick={prevSlide}
                        className="absolute top-1/2 left-0 -translate-y-1/2 bg-white/80 rounded-full p-1 shadow-md"
                        aria-label="Previous slide"
                      >
                        <ChevronLeft className="text-blue w-5 h-5" />
                      </button>
                      <button
                        onClick={nextSlide}
                        className="absolute top-1/2 right-0 -translate-y-1/2 bg-white/80 rounded-full p-1 shadow-md"
                        aria-label="Next slide"
                      >
                        <ChevronRight className="text-blue w-5 h-5" />
                      </button>
                    </div>
                  </div>
                ) : (

                  <div className="flex w-full mt-6 justify-center gap-2 sm:gap-3 flex-wrap">
                    {randomPoints?.map((point: any, index: number) => (
                      <div key={index} className="flip-card mt-10 sm:mt-0 min-w-[180px] size-[180px] min-h-[180px] lg:min-w-[150px] lg:min-h-[150px] lg:w-[150px] lg:h-[150px]  2xl:min-w-[180px] 2xl:min-h-[180px] 2xl:w-[180px] 2xl:h-[180px]  ">
                        <div className="flip-card-inner">
                          <div className="flip-card-front flex items-center justify-center p-2 text-center">
                            <Image
                              src={"/case-study/tick_banner.svg"}
                              alt={image_alt}
                              height={100}
                              width={100}
                              className="absolute z-50 -top-10 left-10"
                            />
                            <div className="title text-[14px]">
                              <span className=" text-[20px]  2xl:text-[28px] text-blue">{point?.value}</span>
                              <br />
                              {point?.title}
                            </div>
                          </div>
                          <div className="flip-card-back flex items-center justify-center p-2 text-center">
                            <Image
                              src="/case-study/tick_banner.svg"
                              alt="Tick Back"
                              height={100}
                              width={100}
                              className="absolute z-50 -top-10 right-10"
                            />
                            <div className="title text-[12px] 2xl:text-[14px]">{point?.description}</div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>{" "}
      {showform && (
        <div className="fixed inset-0 flex justify-center items-center w-full z-[998] overflow-y-auto ">
          <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.5 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
          // onClick={() => setshowform(false)}
          className="fixed inset-0 bg-black backdrop-blur-sm">
          </motion.div>
          <motion.div
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
            className="border-2 relative w-[95%] sm:w-[90%] md:w-[60%] lg:w-[50%] 2xl:w-[30%] border-white z-20 rounded-lg bg-blue"
          >
            <button
              onClick={() => setshowform(false)}
              className="absolute top-4 right-4 text-white hover:text-gray-300 transition"
            >
              <X size={20} />
            </button>
            <Popupform
              url={"https://wranker.com/"}
              initialWebsite={websiteUrl}
            />
          </motion.div>
        </div>
      )}
    </div>
  );
};

export default Banner;

export const StyledWrapper = styled.div`
  ul {
    list-style: disc;
  }
  h1,
  h2,
  h6,
  h3,
  h4,
  h5,
  h6 {
    color: #333333;
  }
  strong {
    color: #333333;
  }
  p,
  li,
  td {
    color: #fff; /* Replace with your color */
  }
  ol,
  ul {
    padding-left: 1.5rem;
    list-style-type: disc;
    color: #fff;
    font-size: 20px !important;
  }
  strong {
    color: #fff;
  }
`;
